import { ResponsiveImage } from '@scrippsproduct/networks-ui-library'

import './../../scss/Header.scss'

import laffMoreLogo from './../../images/laff-more-logo.svg'

export default function Header() {    
    return (
        <header className="laffmore-main-header">
            <content-constrainer>
                <ResponsiveImage                     
                    fullSizeUrl={laffMoreLogo}
                    altText="Laff More Logo"
                    loading="eager"             
                />
            </content-constrainer>
        </header>
    )
}
